import {
  Box,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

export const TopActionsCardSkeleton = () => {
  return (
    <>
      <Table sx={{ mt: 1.7 }}>
        <TableHead sx={{ background: "transparent", boxShadow: "none" }}>
          <TableRow sx={{ "&:hover": { backgroundColor: "transparent" } }}>
            <TableCell
              sx={{ borderBottom: "none", background: "transparent", p: 0 }}
            >
              <Skeleton
                variant="text"
                width={50}
                height={24}
                animation="wave"
                sx={{ backgroundColor: "grey.400" }}
              />
            </TableCell>
            <TableCell
              sx={{ borderBottom: "none", background: "transparent", p: 0 }}
            >
              <Skeleton
                variant="text"
                width={120}
                height={24}
                animation="wave"
                sx={{ backgroundColor: "grey.400" }}
              />
            </TableCell>
            <TableCell
              sx={{ borderBottom: "none", background: "transparent", p: 0 }}
            >
              <Skeleton
                variant="text"
                width={40}
                height={24}
                animation="wave"
                sx={{ backgroundColor: "grey.400" }}
              />
            </TableCell>
            <TableCell
              sx={{ borderBottom: "none", background: "transparent", p: 0 }}
            >
              <Skeleton
                variant="text"
                width={80}
                height={24}
                animation="wave"
                sx={{ backgroundColor: "grey.400" }}
              />
            </TableCell>
            <TableCell
              sx={{ borderBottom: "none", background: "transparent", p: 0 }}
            >
              <Skeleton
                variant="text"
                width={100}
                height={24}
                animation="wave"
                sx={{ backgroundColor: "grey.400" }}
              />
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody sx={{ "& td": { pl: 0, py: 1, borderBottom: "none" } }}>
          {Array.from({ length: 5 }).map((_, i) => (
            <TableRow
              key={i}
              sx={{ ":hover": { backgroundColor: "transparent" } }}
            >
              <TableCell width={60}>
                <Skeleton
                  variant="rectangular"
                  height={20}
                  sx={{ width: 56, borderRadius: 10 }}
                  animation="wave"
                />
              </TableCell>
              <TableCell width={"60%"}>
                <Skeleton
                  variant="rectangular"
                  height={20}
                  animation="wave"
                  sx={{ borderRadius: 1, width: "90%" }}
                />
              </TableCell>
              <TableCell width={80}>
                <Skeleton
                  variant="text"
                  height={20}
                  width={35}
                  animation="wave"
                  sx={{ backgroundColor: "grey.400" }}
                />
              </TableCell>
              <TableCell width={160}>
                <Skeleton
                  variant="rectangular"
                  height={20}
                  animation="wave"
                  sx={{ width: 80, borderRadius: 10 }}
                />
              </TableCell>
              <TableCell width={200}>
                <Stack direction="row" spacing={1.5}>
                  <Skeleton
                    variant="rectangular"
                    height={20}
                    sx={{ width: 100, borderRadius: 1 }}
                    animation="wave"
                  />
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Pagination skeleton */}
      <Box
        sx={{
          mt: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Skeleton
          variant="text"
          height={25}
          width={220}
          sx={{ backgroundColor: "grey.400" }}
        />
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          marginRight={2}
        >
          <Skeleton
            variant="rectangular"
            height={20}
            width={60}
            sx={{ borderRadius: 1 }}
          />
          <Skeleton
            variant="rectangular"
            height={20}
            width={60}
            sx={{ borderRadius: 1 }}
          />
        </Stack>
      </Box>
    </>
  );
};
